import { render, staticRenderFns } from "./UserPic.vue?vue&type=template&id=702bf548&lang=pug&"
import script from "./UserPic.vue?vue&type=script&lang=js&"
export * from "./UserPic.vue?vue&type=script&lang=js&"
import style0 from "./UserPic.vue?vue&type=style&index=0&id=702bf548&prod&module=true&lang=sass&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports